export var FacebookMessageDirection;
(function (FacebookMessageDirection) {
    FacebookMessageDirection[FacebookMessageDirection["LX_TO_FACEBOOK"] = 0] = "LX_TO_FACEBOOK";
    FacebookMessageDirection[FacebookMessageDirection["FACEBOOK_TO_LX"] = 1] = "FACEBOOK_TO_LX";
})(FacebookMessageDirection || (FacebookMessageDirection = {}));
export var FacebookMessageType;
(function (FacebookMessageType) {
    FacebookMessageType[FacebookMessageType["TEXT"] = 1] = "TEXT";
    FacebookMessageType[FacebookMessageType["AUDIO"] = 2] = "AUDIO";
    FacebookMessageType[FacebookMessageType["IMAGE"] = 3] = "IMAGE";
    FacebookMessageType[FacebookMessageType["VIDEO"] = 4] = "VIDEO";
    FacebookMessageType[FacebookMessageType["DOCUMENT"] = 5] = "DOCUMENT";
})(FacebookMessageType || (FacebookMessageType = {}));
export var FacebookMessageTypeName;
(function (FacebookMessageTypeName) {
    FacebookMessageTypeName[FacebookMessageTypeName["\u6587\u672C"] = 1] = "\u6587\u672C";
    FacebookMessageTypeName[FacebookMessageTypeName["\u97F3\u9891"] = 2] = "\u97F3\u9891";
    FacebookMessageTypeName[FacebookMessageTypeName["\u56FE\u7247"] = 3] = "\u56FE\u7247";
    FacebookMessageTypeName[FacebookMessageTypeName["\u89C6\u9891"] = 4] = "\u89C6\u9891";
    FacebookMessageTypeName[FacebookMessageTypeName["\u6587\u4EF6"] = 5] = "\u6587\u4EF6";
})(FacebookMessageTypeName || (FacebookMessageTypeName = {}));
export var FbBindStatus;
(function (FbBindStatus) {
    FbBindStatus["NO_OPERATE"] = "\u672A\u64CD\u4F5C\u7ED1\u5B9A";
    FbBindStatus["BIND_SUCCESS"] = "\u7ED1\u5B9A\u6210\u529F";
    FbBindStatus["BIND_FAILED"] = "\u7ED1\u5B9A\u5931\u8D25";
    FbBindStatus["USER_CANCEL"] = "\u7528\u6237\u53D6\u6D88\u6388\u6743";
    FbBindStatus["NO_ALL_PERMISSIONS"] = "\u6CA1\u6709\u52FE\u9009\u5168\u90E8\u6743\u9650";
})(FbBindStatus || (FbBindStatus = {}));
export var FacebookTestEnum;
(function (FacebookTestEnum) {
    FacebookTestEnum[FacebookTestEnum["A"] = 0] = "A";
    FacebookTestEnum[FacebookTestEnum["B"] = 1] = "B";
})(FacebookTestEnum || (FacebookTestEnum = {}));
